import type React from 'react';

import { Card } from '@shared/ui';

import * as st from './styles.module.scss';

interface Props {
	User?: JSX.Element;
	Menu?: JSX.Element;
	Consultation?: JSX.Element;
}

export const Layout: React.FC<Props> = ({ User, Menu, Consultation }) => {
	return (
		<div className={st.modal}>
			<Card className={st.modal__nav}>
				<div className={st.modal__user}>{User}</div>
				<div className={st.modal__menu}>{Menu}</div>
			</Card>
			<section className={st.modal__body}>{Consultation}</section>
		</div>
	);
};
